const NULLREG = '^[sS]*.*[^s][sS]*$'
const MOBILEREG = '^1.{7,}$'
const CHN_NAME_REG = '^[a-zA-Z0-9_\u4e00-\u9fa5 ]+$'
const ENG_NAME_REG = '^[a-zA-Z0-9_ ]+$'
const SEX_NULL_REG = '^[^0]$'
const TYPE_NULL_REG = '^[1-9]\\d*|0$'
//
const cardType = {
  //身份证
  idCard: '1',
  //护照
  passport: 'B',
  //港澳台居民居住证
  HKMCTWResidence: '2',
  //台湾居民来往大陆通行证
  taibaoCard: 'G',
  //军官证
  officerCard: '5',
  //回乡证
  reentryCard: '6',
  //外国人永久居留身份证
  foreignerCard: 'H',
  //港澳居民来往内地通行证
  exitEntryHKMCTWCard: 'C',
  //公务护照
  officialPassport: '9',
  //外交护照
  diplomacyPassport: '10',
  other: '11',
}

//国内常用出行人配置
const commonConfig = {
  passenger_name: {
    //中文名
    isShow: true,
    isRequired: true,
    requiredcCrdTypes: [],
    tips: '请先输入姓名信息',
    validator: NULLREG,
  },
  passenger_type: {
    // 乘客类型
    isShow: true,
    isRequired: true,
    requiredcCrdTypes: [],
    tips: '请选择乘车人类型',
    validator: TYPE_NULL_REG,
  },
  // english_surname:{//英文姓
  //   isShow:true,
  //   isRequired:false,
  //   // 护照、外国人永久居留身份证、公务护照、外交护照，英文名必填
  //   requiredcCrdTypes:['2', '7', '9', '10'],
  //   tips:'请输入英文姓',
  //   validator: NULLREG
  // },
  // english_name:{//英文名
  //   isShow:true,
  //   isRequired:false,
  //   requiredcCrdTypes:['2', '7', '9', '10'],
  //   tips:'请输入英文名',
  //   validator: NULLREG
  // },
  encrypt_phone: {
    //手机号码
    isShow: true,
    isRequired: true,
    requiredcCrdTypes: [],
    tips: '请输入正确的手机号',
    validator: MOBILEREG,
  },
  card: {
    //证件
    isShow: true,
    isRequired: false,
    requiredcCrdTypes: [],
    tips: '',
    validator: NULLREG,
  },
  id_no: {
    //证件号
    isShow: true,
    isRequired: false,
    requiredcCrdTypes: [],
    tips: '请输入有效的证件号码',
    validator: NULLREG,
  },
  expire_date: {
    //证件号有效期
    isShow: false,
    isRequired: false,
    requiredcCrdTypes: [],
    tips: '请选择证件有效期',
    validator: NULLREG,
  },
  born_date: {
    //出生日期
    isShow: false,
    isRequired: false,
    // 除身份证外的其他证件，出生日期必填
    requiredcCrdTypes: ['2', '3', '4', '5', '6', '7', '8', '9', '10', '11'],
    tips: '请选择出生日期',
    validator: NULLREG,
  },
  sex: {
    //性别
    isShow: false,
    isRequired: false,
    // 台胞证、回乡证、往来港澳通行证，性别必填
    // requiredcCrdTypes:['4', '6', '8'],
    requiredcCrdTypes: [],
    tips: '请选择性别',
    validator: SEX_NULL_REG,
  },
  nickname: {
    isShow: false,
    isRequired: false,
    requiredcCrdTypes: [],
    tips: '请输入昵称',
    validator: NULLREG,
  },
  remark: {
    isShow: false,
    isRequired: false,
    requiredcCrdTypes: [],
    tips: '请输入备注',
    validator: NULLREG,
  },
  nationlity: {
    isShow: false,
    isRequired: false,
    requiredcCrdTypes: [],
    tips: '请选择国籍',
    validator: function (obj, msg) {
      if (!obj || !obj.country_code) {
        return msg
      }
    },
  },
}
//国内火车选择出行人配置
const domesticTrainConfig = {
  ...commonConfig,
  expire_date: {
    //证件号有效期
    isShow: false,
    isRequired: false,
    requiredcCrdTypes: [
      cardType.passport,
      cardType.foreignerCard,
      cardType.taibaoCard,
      cardType.reentryCard,
      cardType.exitEntryHKMCTWCard,
    ],
    tips: '请选择证件有效期',
    validator: NULLREG,
  },
  born_date: {
    //出生日期
    isShow: false,
    isRequired: false,
    // 除身份证外的其他证件，出生日期必填
    requiredcCrdTypes: [
      cardType.passport,
      cardType.foreignerCard,
      cardType.taibaoCard,
      cardType.reentryCard,
      cardType.exitEntryHKMCTWCard,
    ],
    tips: '请选择出生日期',
    validator: NULLREG,
  },
  sex: {
    //性别
    isShow: false,
    isRequired: false,
    requiredcCrdTypes: [
      // cardType.idCard,
      // cardType.HKMCTWResidence,
      cardType.passport,
      cardType.exitEntryHKMCTWCard,
      cardType.taibaoCard,
      cardType.foreignerCard,
    ],
    tips: '请选择性别',
    validator: SEX_NULL_REG,
  },
  nationlity: {
    ...commonConfig.nationlity,
    isShow: false,
    requiredcCrdTypes: [cardType.passport, cardType.foreignerCard],
    isRequired: false,
    tips: '请选择国籍',
    validator: function (obj, msg) {
      if (!obj || !obj.country_code) {
        return msg
      }
    },
  },
}

//国内选择出行人配置
const domesticConfig = {
  ...commonConfig,
  // english_surname:{//英文姓
  //   ...commonConfig.english_surname,
  //   isShow:false,
  //   isRequired:false,
  // },
  // english_name:{//英文名
  //   ...commonConfig.english_name,
  //   isShow:false,
  //   isRequired:false,
  // },
}
//国内机票选择出行人配置
const domesticFlightConfig = {
  ...commonConfig,
  english_surname: {
    //英文姓
    ...commonConfig.english_surname,
    isShow: false,
    isRequired: false,
    // 护照、外国人永久居留身份证、公务护照、外交护照，英文名必填 航信新增 台胞证、军官证、回乡证
    requiredcCrdTypes: [
      cardType.passport,
      cardType.taibaoCard,
      cardType.officerCard,
      cardType.reentryCard,
      cardType.foreignerCard,
      cardType.officialPassport,
      cardType.diplomacyPassport,
    ],
  },
  english_name: {
    //英文名
    ...commonConfig.english_name,
    isShow: false,
    isRequired: false,
    // 护照、外国人永久居留身份证、公务护照、外交护照，英文名必填 航信新增 台胞证、军官证、回乡证
    requiredcCrdTypes: [
      cardType.passport,
      cardType.taibaoCard,
      cardType.officerCard,
      cardType.reentryCard,
      cardType.foreignerCard,
      cardType.officialPassport,
      cardType.diplomacyPassport,
    ],
  },
  sex: {
    //性别
    ...commonConfig.sex,
    isShow: false,
    isRequired: false,
    requiredcCrdTypes: [
      cardType.passport,
      cardType.taibaoCard,
      cardType.officerCard,
      cardType.reentryCard,
      cardType.foreignerCard,
    ],
    tips: '请选择性别',
    validator: SEX_NULL_REG,
  },
  expire_date: {
    //证件号有效期
    isShow: false,
    isRequired: false,
    requiredcCrdTypes: [
      cardType.passport,
      cardType.taibaoCard,
      cardType.officerCard,
      cardType.reentryCard,
      cardType.foreignerCard,
    ],
    tips: '请选择证件有效期',
    validator: NULLREG,
  },
  nationlity: {
    ...commonConfig.nationlity,
    isShow: false,
    requiredcCrdTypes: [
      cardType.passport,
      cardType.taibaoCard,
      cardType.officerCard,
      cardType.reentryCard,
      cardType.foreignerCard,
    ],
    isRequired: false,
    tips: '请选择国籍',
    validator: function (obj, msg) {
      if (!obj || !obj.country_code) {
        return msg
      }
    },
  },
}
//国际选择出行人配置
const internationalConfig = {
  ...commonConfig,
  passenger_name: {
    //中文名
    ...commonConfig.passenger_name,
    isShow: false,
    isRequired: false,
  },
  english_surname: {
    //英文姓
    ...commonConfig.english_surname,
    isShow: true,
    isRequired: true,
  },
  english_name: {
    //英文名
    ...commonConfig.english_name,
    isShow: true,
    isRequired: true,
  },
  expire_date: {
    //证件号有效期
    ...commonConfig.expire_date,
    isShow: true,
    isRequired: true,
  },
  born_date: {
    //出生日期
    ...commonConfig.born_date,
    isShow: true,
    isRequired: true,
  },
  sex: {
    //性别
    ...commonConfig.sex,
    isShow: true,
    isRequired: true,
  },
  nationlity: {
    ...commonConfig.nationlity,
    isShow: true,
    isRequired: true,
  },
}

export const contentConfig = {
  international_flight: internationalConfig, //国际机票
  international_hotel: internationalConfig, //国际酒店
  flight: domesticFlightConfig, //国内机票
  train: domesticTrainConfig, //国内火车票
  hotel: domesticConfig,
  // {
  //   ...domesticConfig,
  //   english_surname:{//英文姓
  //     ...domesticConfig.english_surname,
  //     isShow:true,
  //     isRequired:false,
  //   },
  //   english_name:{//英文名
  //     ...domesticConfig.english_name,
  //     isShow:true,
  //     isRequired:false,
  //   },
  // },//国内酒店
  common: {
    //常用出行人
    ...commonConfig,
    passenger_name: {
      //中文名
      ...commonConfig.passenger_name,
      isRequired: false,
    },
  }, //常用出行人配置
  englishModeHotel: {
    ...domesticConfig,
    passenger_name: {
      //中文名
      ...domesticConfig.passenger_name,
      isShow: false,
      isRequired: false,
    },
    english_surname: {
      //英文姓
      ...domesticConfig.english_surname,
      isShow: true,
      isRequired: true,
    },
    english_name: {
      //英文名
      ...domesticConfig.english_name,
      isShow: true,
      isRequired: true,
    },
  },
}
let hotelTipText =
  '根据酒店实名制要求，预订酒店需提供入住人以上个人信息，为保证您的正常入住，请如实填写入住人信息。滴滴企业版将通过加密等方式保护您录入的信息，并在具体预订酒店过程中授权提供给您提供服务的酒店供应商。'
let flightTipText =
  '根据航空公司要求，购买机票需提交乘机人身份证件信息，并在乘机时出具对应身份证件用于验证，请确保录入信息真实有效。滴滴企业版将通过加密等方式保护您录入的身份证件信息，并在具体订票过程中授权提供给您提供服务的产品供应商、承运人、机票分销系统服务商。'
export const tipTextConfig = {
  hotel: hotelTipText,
  flight: flightTipText,
  trainNoLogin: '点击确定或保存表示您已阅读并同意以下内容：您同意您在滴滴平台录入的上述乘车人信息（包括姓名、手机号码及证件信息）将用于预定机票、火车票等所有根据航空及铁路客运机构要求需实名制的旅游产品，您需在使用产品时出具对应证件进行验证，请确保此信息真实有效。滴滴平台将通过加密等方式保护此信息，且仅在经过您授权后并有具体交易时提供给相关第三方（服务供应商、铁路12306及铁路代售点等）。',
  trainNoLoginMini: '点击确定或保存表示您已阅读并同意以下内容：您同意您在滴滴火车票/机票录入的上述乘车人信息（包括姓名、手机号码及证件信息）将用于预定机票、火车票等所有根据航空及铁路客运机构要求需实名制的旅游产品，您需在使用产品时出具对应证件进行验证，请确保此信息真实有效。滴滴火车票/机票将通过加密等方式保护此信息，且仅在经过您授权后并有具体交易时提供给相关第三方（服务供应商、铁路12306及铁路代售点等）。',
  train:
    '根据铁路客运机构实名制要求，购买火车票需提交乘车人身份证件信息，并在乘车时出具对应身份证件用于验证，请您确保录入信息真实有效。我们将采取措施保护您录入的身份证件信息，并提供给服务方青岛景行科技有限公司和铁路12306为您提供服务。',
  hasTravelAuth:
    '您已知晓您在滴滴企业版录入的以上个人信息，将分别用于您使用滴滴企业版用车服务、预订需要实名制的机票、酒店产品，并在使用时进行验证，请确保此信息的真实有效。滴滴企业版将通过加密等方式保护此信息，且仅在有具体交易时授权提供给相关第三方。',
  hasNoTravelAuth:
    '您已知晓您在滴滴企业版录入的出行人姓名、手机号，将用于您使用滴滴企业版用车服务，并在使用时进行验证，请确保上述信息的真实有效。滴滴企业版将通过加密等方式保护上述信息，且仅在有具体交易时授权提供给相关第三方。',
  international_flight: flightTipText, //国际机票
  international_hotel: hotelTipText, //国际酒店
}

const flightNameTips = '姓名需与证件一致，否则会影响登机'
const otherNameTips = '姓名需与证件一致'
export const nameTipsConfig = {
  flight: flightNameTips,
  train: otherNameTips, //国内火车票
  hotel: otherNameTips,
  international_flight: flightNameTips, //国际机票
  international_hotel: otherNameTips, //国际酒店
  common: otherNameTips, // 常用出行人
}

export const componentsConfig = {
  passenger_name: 'es-contact-name',
  english_surname: 'es-english-surname',
  english_name: 'es-english-name',
  passenger_type: 'es-contact-type',
  encrypt_phone: 'es-contact-phone',
  born_date: 'es-birth-date',
  sex: 'es-contact-sex',
  nickname: 'es-contact-nickname',
  remark: 'es-contact-remark',
  nationlity: 'es-nationlity',
}

export const titleConfig = {
  flight: '乘机人',
  train: '乘车人', //国内火车票
  hotel: '入住人',
  international_flight: '乘机人', //国际机票
  international_hotel: '入住人', //国际酒店
  common: '出行人', // 常用出行人
}

const flightSelectedIsOverTips = {
  maxNumber: 9,
  overTips: '一个订单最多只可添加9位乘机人',
  noOverTips: '余票不足，不可添加更多乘机人',
}
const trainSelectedIsOverTips = {
  maxNumber: 9,
  overTips: '一个订单最多只可添加9位乘车人',
  noOverTips: '余票不足，不可添加更多乘车人',
}
const trainUnionSelectedIsOverTips = {
  maxNumber: 5,
  overTips: '一个订单最多只可添加5位乘车人',
  noOverTips: '余票不足，不可添加更多乘车人'
};
const trainChangeSelectedIsOverTips = {
  maxNumber: 5,
  overTips: '最多支持勾选5名乘车人',
  noOverTips: ''
};
const trainRefundSelectedIsOverTips = {
  maxNumber: 9,
  overTips: '一个订单最多只可添加9位',
  noOverTips: ''
};
;
const hotelSelectedIsOverTips = {
  maxNumber: 1000,
  overTips: '如需添加更多入住人，请增加房间数量',
  noOverTips: '如需添加更多入住人，请增加房间数量',
}

export const selectedOverTipsConfig = {
  flight: flightSelectedIsOverTips,
  train: trainSelectedIsOverTips,
  trainRefund: trainRefundSelectedIsOverTips,
  trainChange: trainChangeSelectedIsOverTips,
  trainUnion: trainUnionSelectedIsOverTips,
  hotel: hotelSelectedIsOverTips,
  international_flight: flightSelectedIsOverTips, //国际机票
  international_hotel: hotelSelectedIsOverTips, //国际酒店
}

const flightBirthDateTips = '出生日期用于判定机票旅客类型'

export const birthDateTipsConfig = {
  common: '出生日期用于判定机票、火车票、国际酒店旅客类型',
  flight: flightBirthDateTips,
  train: '出生日期用于判定火车票旅客类型',
  hotel: '出生日期用于判定酒店旅客类型',
  international_flight: flightBirthDateTips, //国际机票
  international_hotel: '出生日期用于判定国际酒店旅客类型', //国际酒店
}
